import { IFilterList } from '@/utils/interfaces/FilterListInterface'
import { toPartialQueryString } from '@/utils/parsers/QueryString'
import { IFilterInformationBooleanWrapper } from '../../utils/interfaces/FilterInformationInterface'

export class BrandListFilterModel implements IFilterList {
    idSource:string = ''
    idExternalChannel:string = ''
    allowExport:IFilterInformationBooleanWrapper
    title:string = ''
    name:string = ''
    description:string = ''
    keywords:string = ''

    constructor(c?:Partial<BrandListFilterModel>) {
        Object.assign(this, c)
    }

    isFilterFilled():boolean {
        return !!this.idSource || 
               !!this.idExternalChannel ||
               !!(this.allowExport?.bool !== undefined) || 
               !!this.title || 
               !!this.name || 
               !!this.description || 
               !!this.keywords
    }

    toPartialQueryString():string {
        let allowExport

        if (typeof this.allowExport === "boolean") {
            allowExport = this.allowExport
        } else if (typeof this.allowExport === "object") {
            allowExport = this.allowExport.bool
        }

        const tmp = {
            ...this,
            allowExport,
        }

        return toPartialQueryString(tmp)
    }
}
